module.exports = {
      id: "print-on-dibond-companies-usage",
      viewBox: "0 0 352.1 476.5",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#print-on-dibond-companies-usage",
      toString: function () {
        return this.url;
      }
    }